package guide.kuki.app.engine

/**
 * Simple lat/lng pair used as input to block lookup operations.
 * Mirrors the Leaflet LatLng interface from the original app.
 */
data class LatLng(val lat: Double, val lng: Double)
